export default {"src":"/_next/static/media/add_file.40beaf6a.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};